import { BroadcastifyFeed } from 'features/broadcastify/broadcastify.types';
import {
  UseBroadcastifyFeedsProps,
  useBroadcastifyFeeds,
} from '../useBroadcastifyFeeds';

type UseBroadcastifyFeedProps = UseBroadcastifyFeedsProps & { feedId: number };

type UseBroadcastifyFeed = {
  broadcastifyFeed?: BroadcastifyFeed;
  isLoading: boolean;
  error: Error | null;
};

export const useBroadcastifyFeed = (
  props: UseBroadcastifyFeedProps,
): UseBroadcastifyFeed => {
  const { feedId, lat, lng } = props;

  const {
    broadcastifyFeeds = [],
    isLoading,
    error,
  } = useBroadcastifyFeeds({ lat, lng });

  const broadcastifyFeed = broadcastifyFeeds.find(
    (feed: BroadcastifyFeed) => feed.feedId === feedId,
  );

  return {
    broadcastifyFeed,
    isLoading,
    error,
  };
};
